type XcodeLogoProps = React.SVGProps<SVGSVGElement>

export const XcodeLogo = (props: XcodeLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 85 85"
    focusable="false"
    aria-label="Azure Data Studio icon"
    {...props}
  >
    <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="42.4648" x2="42.4648" y1="75.8127" y2="9.15344">
      <stop offset="0" stopColor="#1578e4" />
      <stop offset="1" stopColor="#00c3f2" />
    </linearGradient>
    <linearGradient id="b">
      <stop offset="0" stopColor="#1492e7" />
      <stop offset="1" stopColor="#dbedfb" />
    </linearGradient>
    <linearGradient
      id="c"
      gradientUnits="userSpaceOnUse"
      x1="62.4464"
      x2="62.4464"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="d"
      gradientUnits="userSpaceOnUse"
      x1="59.1295"
      x2="59.1295"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="e"
      gradientUnits="userSpaceOnUse"
      x1="42.4648"
      x2="42.4648"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="f"
      gradientUnits="userSpaceOnUse"
      x1="39.1478"
      x2="39.1478"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="g"
      gradientUnits="userSpaceOnUse"
      x1="35.8315"
      x2="35.8315"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="h"
      gradientUnits="userSpaceOnUse"
      x1="32.5145"
      x2="32.5145"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="i"
      gradientUnits="userSpaceOnUse"
      x1="29.1975"
      x2="29.1975"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="j"
      gradientUnits="userSpaceOnUse"
      x1="25.8002"
      x2="25.8002"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient
      id="k"
      gradientUnits="userSpaceOnUse"
      x1="22.4832"
      x2="22.4832"
      xlinkHref="#b"
      y1="52.9032"
      y2="47.9347"
    />
    <linearGradient id="l">
      <stop offset="0" stopColor="#1285e7" />
      <stop offset="1" stopColor="#00b5ef" />
    </linearGradient>
    <linearGradient
      id="m"
      gradientUnits="userSpaceOnUse"
      x1="48.8617"
      x2="48.8617"
      xlinkHref="#l"
      y1="62.5877"
      y2="21.6762"
    />
    <linearGradient id="n" gradientUnits="userSpaceOnUse" x1="58.0816" x2="35.9132" y1="62.4073" y2="24.0098">
      <stop offset="0" stopColor="#2b90e7" />
      <stop offset="1" stopColor="#00b6ef" />
    </linearGradient>
    <linearGradient id="o" gradientUnits="userSpaceOnUse" x1="59.15" x2="36.2465" y1="62.639" y2="22.9693">
      <stop offset="0" stopColor="#3795ea" />
      <stop offset="1" stopColor="#49c4f2" />
    </linearGradient>
    <linearGradient id="p" gradientUnits="userSpaceOnUse" x1="60.4469" x2="37.2353" y1="62.2459" y2="22.0422">
      <stop offset="0" stopColor="#3696ea" />
      <stop offset="1" stopColor="#90d9f6" />
    </linearGradient>
    <linearGradient id="q" gradientUnits="userSpaceOnUse" x1="61.4802" x2="38.5588" y1="61.3142" y2="21.6132">
      <stop offset="0" stopColor="#3097ea" />
      <stop offset="1" stopColor="#b5e5f9" />
    </linearGradient>
    <linearGradient id="r" gradientUnits="userSpaceOnUse" x1="61.8129" x2="39.6718" y1="60.2212" y2="21.8716">
      <stop offset="0" stopColor="#3a98ea" />
      <stop offset="1" stopColor="#bce7fa" />
    </linearGradient>
    <linearGradient id="s">
      <stop offset="0" stopColor="#00a4ec" />
      <stop offset="1" stopColor="#b9dff6" />
    </linearGradient>
    <linearGradient
      id="t"
      gradientUnits="userSpaceOnUse"
      x1="45.1436"
      x2="49.4441"
      xlinkHref="#s"
      y1="40.6579"
      y2="38.175"
    />
    <linearGradient
      id="u"
      gradientUnits="userSpaceOnUse"
      x1="43.4875"
      x2="47.7873"
      xlinkHref="#s"
      y1="37.7891"
      y2="35.3062"
    />
    <linearGradient id="v">
      <stop offset="0" stopColor="#00b4ef" />
      <stop offset="1" stopColor="#c3e9fa" />
    </linearGradient>
    <linearGradient
      id="w"
      gradientUnits="userSpaceOnUse"
      x1="38.4691"
      x2="42.7417"
      xlinkHref="#v"
      y1="29.0985"
      y2="26.6321"
    />
    <linearGradient
      id="x"
      gradientUnits="userSpaceOnUse"
      x1="36.805"
      x2="41.1055"
      xlinkHref="#v"
      y1="26.215"
      y2="23.7321"
    />
    <linearGradient
      id="y"
      gradientUnits="userSpaceOnUse"
      x1="36.2352"
      x2="36.2352"
      xlinkHref="#l"
      y1="62.6881"
      y2="21.7772"
    />
    <linearGradient id="z" gradientUnits="userSpaceOnUse" x1="27.0147" x2="49.1831" y1="62.5089" y2="24.1128">
      <stop offset="0" stopColor="#3194e9" />
      <stop offset="1" stopColor="#71cff4" />
    </linearGradient>
    <linearGradient id="A" gradientUnits="userSpaceOnUse" x1="25.9403" x2="48.8464" y1="62.742" y2="23.0669">
      <stop offset="0" stopColor="#5aa6ec" />
      <stop offset="1" stopColor="#a2def8" />
    </linearGradient>
    <linearGradient id="B" gradientUnits="userSpaceOnUse" x1="24.6487" x2="47.8603" y1="62.3455" y2="22.1418">
      <stop offset="0" stopColor="#66abee" />
      <stop offset="1" stopColor="#bee8fa" />
    </linearGradient>
    <linearGradient id="C" gradientUnits="userSpaceOnUse" x1="23.6194" x2="46.5408" y1="61.4138" y2="21.7129">
      <stop offset="0" stopColor="#7bb6f0" />
      <stop offset="1" stopColor="#b1e3f9" />
    </linearGradient>
    <linearGradient id="D" gradientUnits="userSpaceOnUse" x1="23.2794" x2="45.4318" y1="60.3447" y2="21.9752">
      <stop offset="0" stopColor="#5aa6ec" />
      <stop offset="1" stopColor="#afe3f9" />
    </linearGradient>
    <linearGradient id="E">
      <stop offset="0" stopColor="#c1e7fa" />
      <stop offset="1" stopColor="#89d4f5" />
    </linearGradient>
    <linearGradient
      id="F"
      gradientUnits="userSpaceOnUse"
      x1="44.0685"
      x2="48.369"
      xlinkHref="#E"
      y1="23.6998"
      y2="26.1827"
    />
    <linearGradient
      id="G"
      gradientUnits="userSpaceOnUse"
      x1="42.4044"
      x2="46.7048"
      xlinkHref="#E"
      y1="26.5824"
      y2="29.0647"
    />
    <linearGradient
      id="H"
      gradientUnits="userSpaceOnUse"
      x1="40.6891"
      x2="44.9889"
      xlinkHref="#E"
      y1="29.5541"
      y2="32.0364"
    />
    <linearGradient id="I" gradientUnits="userSpaceOnUse" x1="39.021" x2="43.3208" y1="32.4428" y2="34.9257">
      <stop offset="0" stopColor="#b0dff8" />
      <stop offset="1" stopColor="#52bdf2" />
    </linearGradient>
    <linearGradient id="J">
      <stop offset="0" stopColor="#b4def8" />
      <stop offset="1" stopColor="#4eb5f0" />
    </linearGradient>
    <linearGradient
      id="K"
      gradientUnits="userSpaceOnUse"
      x1="37.3535"
      x2="41.6546"
      xlinkHref="#J"
      y1="35.3308"
      y2="37.8137"
    />
    <linearGradient
      id="L"
      gradientUnits="userSpaceOnUse"
      x1="35.6867"
      x2="39.9865"
      xlinkHref="#J"
      y1="38.2188"
      y2="40.7011"
    />
    <linearGradient id="M" gradientUnits="userSpaceOnUse" x1="34.0259" x2="38.325" y1="41.0962" y2="43.5784">
      <stop offset="0" stopColor="#b5ddf8" />
      <stop offset="1" stopColor="#46aeee" />
    </linearGradient>
    <linearGradient id="N" gradientUnits="userSpaceOnUse" x1="32.3631" x2="36.6636" y1="43.9742" y2="46.4571">
      <stop offset="0" stopColor="#96cef4" />
      <stop offset="1" stopColor="#46aaee" />
    </linearGradient>
    <linearGradient id="O">
      <stop offset="0" stopColor="#8fc1f2" />
      <stop offset="1" stopColor="#3193ea" />
    </linearGradient>
    <linearGradient
      id="P"
      gradientUnits="userSpaceOnUse"
      x1="28.3681"
      x2="31.6632"
      xlinkHref="#O"
      y1="53.2146"
      y2="55.1172"
    />
    <linearGradient
      id="Q"
      gradientUnits="userSpaceOnUse"
      x1="25.6554"
      x2="29.9559"
      xlinkHref="#O"
      y1="55.5933"
      y2="58.0762"
    />
    <linearGradient
      id="R"
      gradientUnits="userSpaceOnUse"
      x1="23.9886"
      x2="28.2884"
      xlinkHref="#O"
      y1="58.4793"
      y2="60.9623"
    />
    <linearGradient id="S" gradientUnits="userSpaceOnUse" x1="50.9482" x2="59.2204" y1="43.1196" y2="47.1537">
      <stop offset=".001" />
      <stop offset="1" stopOpacity="0" />
    </linearGradient>
    <radialGradient
      id="T"
      cx="0"
      cy="0"
      gradientTransform="matrix(-4.82889291 9.5986806 -16.60922195 -8.35574777 63.2453 16.6879)"
      gradientUnits="userSpaceOnUse"
      r="1"
    >
      <stop offset="0" />
      <stop offset="1" stopOpacity="0" />
    </radialGradient>
    <radialGradient
      id="U"
      cx="0"
      cy="0"
      gradientTransform="matrix(4.71106621 2.30962025 -1.31470813 2.68168633 34.0047 76.339)"
      gradientUnits="userSpaceOnUse"
      r="1"
    >
      <stop offset=".417" stopColor="#0c0c12" />
      <stop offset="1" stopColor="#3d4651" />
    </radialGradient>
    <linearGradient id="V" gradientUnits="userSpaceOnUse" x1="56.2846" x2="62.7685" y1="26.014" y2="29.3177">
      <stop offset="0" stopColor="#344351" />
      <stop offset=".1" stopColor="#9697a0" />
      <stop offset=".181" stopColor="#8b8c95" />
      <stop offset=".351" stopColor="#787a83" />
      <stop offset=".47" stopColor="#71747d" />
      <stop offset=".591" stopColor="#777982" />
      <stop offset=".749" stopColor="#87898f" />
      <stop offset=".8" stopColor="#8e8f94" />
      <stop offset=".849" stopColor="#3d3b42" />
      <stop offset=".9" stopColor="#606e84" />
    </linearGradient>
    <linearGradient id="W" gradientUnits="userSpaceOnUse" x1="78.2824" x2="70.9638" y1="19.4286" y2="9.53873">
      <stop offset=".27" stopColor="#262b33" />
      <stop offset=".45" stopColor="#74747e" />
      <stop offset=".54" stopColor="#b0b0bc" />
      <stop offset=".73" stopColor="#74747e" />
    </linearGradient>
    <linearGradient id="X" gradientUnits="userSpaceOnUse" x1="65.438" x2="76.2443" y1="20.2034" y2="18.8076">
      <stop offset=".14" stopColor="#606e84" />
      <stop offset=".4" stopColor="#9899a5" />
      <stop offset=".73" stopColor="#475768" />
      <stop offset=".92" stopColor="#262b33" />
    </linearGradient>
    <linearGradient id="Y" gradientUnits="userSpaceOnUse" x1="70.4756" x2="69.4271" y1="21.1223" y2="15.1762">
      <stop offset="0" stopColor="#101215" stopOpacity=".1" />
      <stop offset=".46" stopColor="#101215" stopOpacity=".7" />
      <stop offset=".7" stopColor="#474951" />
      <stop offset=".91" stopColor="#7b7d88" />
    </linearGradient>
    <linearGradient id="Z" gradientUnits="userSpaceOnUse" x1="38.6026" x2="48.6339" y1="54.2678" y2="59.2038">
      <stop offset=".115" stopColor="#2c3952" />
      <stop offset=".374" stopColor="#3d414e" />
      <stop offset=".55" stopColor="#474a54" />
      <stop offset=".754" stopColor="#4e5057" />
      <stop offset=".892" stopColor="#323945" />
      <stop offset="1" stopColor="#143052" />
    </linearGradient>
    <linearGradient id="aa" gradientUnits="userSpaceOnUse" x1="54.1264" x2="61.884" y1="21.0368" y2="4.01559">
      <stop offset=".118" stopColor="#6d7078" stopOpacity="0" />
      <stop offset=".2" stopColor="#6d7078" stopOpacity=".7" />
      <stop offset=".34" stopColor="#35363a" />
      <stop offset=".374" stopColor="#1d1f22" />
      <stop offset=".4" stopColor="#101215" />
      <stop offset=".5" stopColor="#16171a" />
      <stop offset=".56" stopColor="#292a2e" />
      <stop offset=".688" stopColor="#4b4d51" />
      <stop offset=".807" stopColor="#63666b" />
      <stop offset=".915" stopColor="#72757b" />
      <stop offset="1" stopColor="#777a80" />
    </linearGradient>
    <linearGradient id="ab" gradientUnits="userSpaceOnUse" x1="45.8628" x2="60.447" y1="11.1808" y2="11.1808">
      <stop offset="0" stopColor="#4a4d56" />
      <stop offset="1" stopColor="#29292d" />
    </linearGradient>
    <linearGradient id="ac" gradientUnits="userSpaceOnUse" x1="45.8628" x2="58.4734" y1="7.76773" y2="7.76773">
      <stop offset="0" stopColor="#767880" />
      <stop offset=".41" stopColor="#0c0a0b" />
    </linearGradient>
    <linearGradient id="ad" gradientUnits="userSpaceOnUse" x1="77.2517" x2="82.1492" y1="23.0802" y2="14.5974">
      <stop offset="0" stopColor="#858997" />
      <stop offset=".23" stopColor="#244668" />
      <stop offset=".282" stopColor="#1a3249" />
      <stop offset=".4" stopColor="#040506" />
      <stop offset=".464" stopColor="#313236" />
      <stop offset=".546" stopColor="#65656e" />
      <stop offset=".607" stopColor="#868691" />
      <stop offset=".64" stopColor="#92929e" />
    </linearGradient>
    <path
      d="m23.707 9.16406h37.5196c8.0351 0 14.5429 6.50784 14.5429 14.54294v37.5196c0 8.0351-6.5078 14.5429-14.5429 14.5429h-37.5196c-8.0351 0-14.54294-6.5078-14.54294-14.5429v-37.5196c0-8.0351 6.50784-14.54294 14.54294-14.54294z"
      fill="url(#a)"
    />
    <path
      d="m60.0977 12.75h-35.2618c-6.707 0-12.1523 5.4453-12.1523 12.1523v35.2618c0 6.707 5.4453 12.1523 12.1523 12.1523h35.2618c6.707 0 12.1523-5.4453 12.1523-12.1523v-35.3282c0-6.707-5.4453-12.0859-12.1523-12.0859zm11.1562 47.5469c0 6.1094-4.9141 11.0234-11.0234 11.0234h-35.5274c-6.0429 0-11.0234-4.914-11.0234-11.0234v-35.5938c0-6.1093 4.9141-11.0234 11.0234-11.0234h35.5938c6.0429 0 11.0234 4.9141 11.0234 11.0234v35.5938z"
      fill="#fff"
    />
    <path
      d="m42.5664 15.1406c-15.0078 0-27.2266 12.2188-27.2266 27.2266s12.2188 27.2266 27.2266 27.2266c15.0742 0 27.2266-12.2188 27.2266-27.2266s-12.2188-27.2266-27.2266-27.2266zm0 54.0547c-14.8086 0-26.8281-12.0195-26.8281-26.8281s12.0195-26.8281 26.8281-26.8281 26.8281 12.0195 26.8281 26.8281-12.0195 26.8281-26.8281 26.8281z"
      fill="#69c5f3"
    />
    <path
      d="m42.5664 20.7188c-12.0195 0-21.7148 9.6953-21.7148 21.7148s9.6953 21.6484 21.7148 21.6484 21.7148-9.6953 21.7148-21.7148-9.7617-21.6484-21.7148-21.6484zm0 42.8984c-11.7539 0-21.25-9.4961-21.25-21.25s9.4961-21.25 21.25-21.25 21.25 9.4961 21.25 21.25-9.5625 21.25-21.25 21.25z"
      fill="#68c5f4"
    />
    <path
      d="m21.7813 47.3477h41.4375c1.7265 0 3.0547 1.3945 3.0547 3.0546 0 1.7266-1.3946 3.0547-3.0547 3.0547h-41.4375c-1.7266 0-3.0547-1.3945-3.0547-3.0547-.0664-1.6601 1.3281-3.0546 3.0547-3.0546z"
      fill="#fff"
    />
    <path
      d="m21.6484 47.9453h41.5703c1.3282 0 2.4571 1.0625 2.4571 2.457v.0665c0 1.3281-1.0625 2.457-2.4571 2.457h-41.5703c-1.3281 0-2.457-1.0625-2.457-2.457v-.1329c.0664-1.3281 1.1289-2.3906 2.457-2.3906z"
      fill="#0a93e9"
    />
    <path d="m20.6523 52.6602h43.6289l.3321-.1993h-44.293z" fill="#1694ea" />
    <path d="m19.6563 51.8633h45.5546l.1329-.1992h-45.8204z" fill="#319dec" />
    <path d="m19.2578 50.6016h46.418v-.2657h-46.418z" fill="#65b1ee" />
    <path d="m19.7227 48.9414h45.5546l.0665.1328.0664.1328h-45.8204l.0665-.1328z" fill="#8ec6f3" />
    <path d="m20.7188 48.1445h43.5625l.1992.0664.1992.1329h-44.3594l.1992-.1329z" fill="#95caf3" />
    <path
      d="m62.0234 47.9453h-.332s1.1289.7969 1.1289 2.5899c0 1.6601-1.1289 2.3906-1.1289 2.3906h.332s1.1289-.5313 1.1289-2.3906c0-1.9922-1.1289-2.5899-1.1289-2.5899z"
      fill="url(#c)"
    />
    <path
      d="m58.8359 47.9453h-.332s.9961.9297.9961 2.5899c0 1.4609-.9961 2.3906-.9961 2.3906h.332s.9961-.7305.9961-2.3906c-.0664-1.793-.9961-2.5899-.9961-2.5899z"
      fill="url(#d)"
    />
    <path d="m42.3008 47.9453h.332v4.9805h-.332z" fill="url(#e)" />
    <path
      d="m39.0469 47.9453h.332s-.1328 1.2617-.1328 2.5899c0 1.1953.1328 2.3906.1328 2.3906h-.332s-.1328-1.1953-.1328-2.3906c0-1.3282.1328-2.5899.1328-2.5899z"
      fill="url(#f)"
    />
    <path
      d="m35.8594 47.9453h.332s-.332 1.2617-.332 2.5899c0 1.1953.332 2.3906.332 2.3906h-.332s-.3321-1.1953-.3321-2.3906c0-1.3282.3321-2.5899.3321-2.5899z"
      fill="url(#g)"
    />
    <path
      d="m32.6055 47.9453h.332s-.4648 1.2617-.4648 2.5899c0 1.1953.4648 2.3906.4648 2.3906h-.332s-.4649-1.1953-.4649-2.3906c0-1.3282.4649-2.5899.4649-2.5899z"
      fill="url(#h)"
    />
    <path
      d="m29.3516 47.9453h.332s-.6641 1.0625-.6641 2.5899c0 1.3281.6641 2.3906.6641 2.3906h-.332s-.6641-1.0625-.6641-2.3906c0-1.5274.6641-2.5899.6641-2.5899z"
      fill="url(#i)"
    />
    <path
      d="m26.0977 47.9453h.332s-.9961.9297-.9961 2.5899c0 1.4609.9961 2.3906.9961 2.3906h-.332s-.9961-.7305-.9961-2.3906c.0664-1.793.9961-2.5899.9961-2.5899z"
      fill="url(#j)"
    />
    <path
      d="m22.9102 47.9453h.332s-1.1289.7969-1.1289 2.5899c0 1.6601 1.1289 2.3906 1.1289 2.3906h-.332s-1.129-.5313-1.129-2.3906c0-1.9922 1.129-2.5899 1.129-2.5899z"
      fill="url(#k)"
    />
    <path
      d="m41.1719 22.6445 20.7187 35.8594c.8633 1.461.3321 3.3203-1.1289 4.1836-1.4609.8633-3.3203.332-4.1836-1.1289l-20.7187-35.8594c-.8633-1.4609-.332-3.3203 1.1289-4.1836 1.4609-.8632 3.3203-.332 4.1836 1.1289z"
      fill="#fff"
    />
    <path
      d="m40.6406 22.91 20.7852 35.9922c.664 1.1289.2656 2.6562-.8633 3.3203l-.1328.0664c-1.1289.6641-2.6563.2656-3.3204-.8633l-20.7851-36.0586c-.6641-1.1289-.2656-2.6562.8633-3.3203l.0664-.0664c1.1953-.6641 2.7226-.2656 3.3867.9297z"
      fill="url(#m)"
    />
    <path d="m35.9922 24.3711 21.7812 37.7852.1328.0664.1329.0664.1328.0664-22.1797-38.3828z" fill="url(#n)" />
    <path d="m36.1914 23.1094 22.7774 39.4453h.2656l-22.9102-39.6445-.0664.1328z" fill="url(#o)" />
    <path d="m37.1211 22.1133 23.2422 40.1758.1992-.1329-23.2422-40.1757z" fill="url(#p)" />
    <path d="m38.7812 21.7148 22.711 39.379-.0664.1328-.0664.1328-22.9102-39.711h.1328z" fill="url(#q)" />
    <path d="m39.9766 22.1133 21.7812 37.7187v.3985l-22.1797-38.3164.1328.0664.1329.0664z" fill="url(#r)" />
    <path
      d="m60.7617 57.707-.1328-.2656s-.1328 1.3281-1.5937 2.2578c-1.3946.8633-2.6563.2656-2.6563.2656l.1328.2657s1.0625.7304 2.6563-.2657c1.5937-.9296 1.5937-2.2578 1.5937-2.2578zm-1.6601-2.789-.1328-.2657s-.3321 1.3282-1.7266 2.125c-1.2617.7969-2.5234.3985-2.5234.3985l.1328.2656s1.1289.4648 2.5898-.3984c1.4609-.8633 1.6602-2.125 1.6602-2.125z"
      fill="#3c98ea"
    />
    <path
      d="m57.5078 52.1289-.1328-.2656s-.5977 1.1289-1.8594 1.8594c-1.1289.664-2.3906.664-2.3906.664l.1328.2656s1.1953 0 2.3906-.664c1.2618-.7305 1.8594-1.8594 1.8594-1.8594z"
      fill="#4ca4ed"
    />
    <path
      d="m55.9141 49.3398-.1329-.2656s-.8632 1.1289-1.9921 1.7266c-1.0625.5976-2.3243.7969-2.3243.7969l.1329.2656s1.2617-.1992 2.3242-.7969c1.0625-.5976 1.9922-1.7266 1.9922-1.7266z"
      fill="#4da7ee"
    />
    <path
      d="m49.3398 38.0508.1329.2656s-1.129.5313-2.2579 1.1289c-1.0625.5977-1.9921 1.3945-1.9921 1.3945l-.1329-.2656s.9961-.7969 1.9922-1.3945c1.1289-.5977 2.2578-1.1289 2.2578-1.1289z"
      fill="url(#t)"
    />
    <path
      d="m47.7461 35.2617.1328.2656s-1.2617.3985-2.3242 1.0625c-1.0625.5977-1.9258 1.5274-1.9258 1.5274l-.1328-.2656s.8633-.9297 1.9258-1.5274c1.0625-.7304 2.3242-1.0625 2.3242-1.0625z"
      fill="url(#u)"
    />
    <path
      d="m44.7578 33.0703c.8633-.2656 1.5274-.3984 1.5274-.3984l-.1328-.2657s-.5977.0665-1.2618.3321c-.3984.1328-.4648.4648-.1328.332z"
      fill="#9dd4f7"
    />
    <path
      d="m42.8984 26.8944.1329.2657s-1.2618-.3321-2.7227.4648c-1.2617.7969-1.5273 2.0586-1.5273 2.0586l-.1329-.2656s.1328-1.1289 1.5274-1.9922c1.4609-.9297 2.7226-.5313 2.7226-.5313z"
      fill="url(#w)"
    />
    <path
      d="m41.3047 24.0389.1992.2656s-1.3281-.5312-2.8554.3321c-1.461.9296-1.461 2.1914-1.461 2.1914l-.1992-.2657s-.1328-1.1289 1.4609-2.125c1.6602-.9961 2.8555-.3984 2.8555-.3984z"
      fill="url(#x)"
    />
    <path
      d="m36.8555 47.3477c5.7773-9.961 12.418-21.5157 12.418-21.5157.8632-1.4609.332-3.3203-1.129-4.1835-1.4609-.8633-3.3203-.3321-4.1836 1.1289 0 0-8.1015 14.0781-14.2109 24.5703zm-3.586 6.1093c-2.789 4.7813-4.7148 8.2344-4.7148 8.2344-.8633 1.461-2.7227 1.9922-4.1836 1.1289s-1.9922-2.7226-1.1289-4.1836c0 0 1.1289-2.0586 2.9219-5.1133 2.2578-.0664 6.375-.0664 7.1054-.0664z"
      fill="#fff"
    />
    <path
      d="m36.125 47.3476c5.8437-10.0937 12.6172-21.8476 12.6172-21.8476.664-1.1289.2656-2.6563-.8633-3.3203l-.0664-.0664c-1.1289-.6641-2.6563-.2657-3.3203.8632 0 0-7.9688 13.8125-14.0782 24.3711zm-3.5196 6.1094c-2.6562 4.6484-4.582 7.9688-4.582 7.9688-.6641 1.1289-2.125 1.5273-3.3203.8632h-.1328c-1.1289-.664-1.5274-2.125-.8633-3.3203 0 0 1.2617-2.1914 3.1875-5.5117z"
      fill="url(#y)"
    />
    <path
      d="m35.9258 47.3477 13.2148-22.8438v-.3984s-7.3047 12.6836-13.414 23.2422zm-3.586 6.1093-5.0468 8.7657-.1993.1328-.1992.0664s2.2578-3.918 5.1797-8.9649z"
      fill="url(#z)"
    />
    <path
      d="m34.9297 47.3477 13.9453-24.1055-.0664-.1328-.0664-.1328s-7.6367 13.2148-14.0117 24.3046zm-3.5195 6.1093-5.3125 9.1641h-.2657s2.2578-3.918 5.3125-9.2305c.1328.0664.2657.0664.2657.0664z"
      fill="url(#A)"
    />
    <path
      d="m33.4688 47.3477c6.5742-11.3555 14.4765-25.1016 14.4765-25.1016l-.1992-.1328-14.6094 25.2344zm-3.586 6.1757c-2.9219 5.1133-5.1133 8.8985-5.1133 8.8985l-.1992-.1328s2.125-3.7188 5.0469-8.7657c.1328-.0664.0664-.0664.2656 0z"
      fill="url(#B)"
    />
    <path
      d="m31.875 47.3477c6.5742-11.3555 14.7422-25.5665 14.7422-25.5665h-.2656s-8.168 14.1446-14.7422 25.5665zm-3.8516 6.1093c-2.6562 4.5821-4.4492 7.7032-4.4492 7.7032l.0664.1328.0664.1328s1.9258-3.3203 4.6485-7.9688z"
      fill="url(#C)"
    />
    <path
      d="m30.8789 47.3477 14.6094-25.3008-.1328.0664-.1328.0664-.0665.0664s-8.1015 14.0117-14.4765 25.1016zm-3.5195 6.1093c-2.3242 4.0508-3.9844 6.9063-3.9844 6.9063v-.5313s1.4609-2.5234 3.7187-6.4414c.1329.0664.1329.0664.2657.0664z"
      fill="url(#D)"
    />
    <path
      d="m43.8281 24.0391-.1328.2656s1.1953-.5976 2.7891.2657c1.4609.7968 1.5273 2.1914 1.5273 2.1914l.1328-.2657s.1328-1.2617-1.5273-2.1914c-1.6602-.9297-2.7891-.2656-2.7891-.2656z"
      fill="url(#F)"
    />
    <path
      d="m42.2344 26.8945-.1328.2656s1.3281-.3984 2.7226.3985c1.3281.7304 1.5938 1.9922 1.5938 1.9922l.1328-.2657s-.1328-1.1953-1.5938-1.9922c-1.5273-.8632-2.7226-.3984-2.7226-.3984z"
      fill="url(#G)"
    />
    <path
      d="m40.5742 29.6836-.1328.2656s1.1953-.0664 2.5234.7305c1.1954.6641 1.793 1.7265 1.793 1.7265l.1328-.2656s-.5976-1.0625-1.7929-1.7265c-1.2618-.7305-2.5235-.7305-2.5235-.7305z"
      fill="url(#H)"
    />
    <path
      d="m38.9805 32.5391-.1328.2656s1.3281.1992 2.457.8633c1.0625.5976 1.8594 1.5937 1.8594 1.5937l.1328-.2656s-.7969-.9961-1.8594-1.5938c-1.1289-.664-2.457-.8632-2.457-.8632z"
      fill="url(#I)"
    />
    <path
      d="m37.3203 35.3281-.1328.2656s1.2617.3321 2.3906.9961c1.0625.5977 1.9258 1.461 1.9258 1.461l.1328-.2656s-.8633-.8633-1.9258-1.461c-1.0625-.5976-2.3906-.9961-2.3906-.9961z"
      fill="url(#K)"
    />
    <path
      d="m35.7266 38.1172-.1993.2656s1.1954.4649 2.3243 1.1289c1.0625.5977 1.9922 1.3281 1.9922 1.3281l.1328-.2656s-.9297-.7305-1.9922-1.3281c-1.0625-.5977-2.2578-1.1289-2.2578-1.1289z"
      fill="url(#L)"
    />
    <path d="m33.9336 41.2383.1328-.2656 4.3164 2.457-.1328.2656z" fill="url(#M)" />
    <path
      d="m32.3398 44.0938.1329-.2657s1.0625.7969 2.1914 1.3946c1.0625.5976 2.125 1.0625 2.125 1.0625l-.1329.1992s-1.1289-.4649-2.1914-1.0625c-1.1289-.5977-2.125-1.3281-2.125-1.3281z"
      fill="url(#N)"
    />
    <path d="m31.2773 47.3477c-.332-.2657-.5312-.4649-.5312-.4649l.1328-.2656s.3984.332.9297.7305z" fill="#73b9f1" />
    <path
      d="m28.6875 53.457c.2656.1993.5313.3985.8633.5977 1.1953.6641 2.3906.5976 2.3906.5976l-.1328.2657s-1.1953.0664-2.3906-.5977c-.4649-.2656-.8633-.5976-1.1289-.8633z"
      fill="url(#P)"
    />
    <path
      d="m25.832 55.3164.1328-.2656s.3321 1.3281 1.793 2.125c1.3281.7304 2.5234.332 2.5234.332l-.1328.2656s-1.0625.4649-2.5234-.332c-1.5273-.8633-1.793-2.125-1.793-2.125z"
      fill="url(#Q)"
    />
    <path
      d="m24.1719 58.1719.1328-.2657s.1328 1.3946 1.7265 2.2579c1.461.7968 2.5899.1992 2.5899.1992l-.1992.2656s-.9961.7305-2.5899-.1992c-1.6601-.9297-1.6601-2.2578-1.6601-2.2578z"
      fill="url(#R)"
    />
    <path d="m45.6875 75.8359 28.4219-59.6992-7.1719-3.3867-29.6172 62.0898s.9297.4649 2.125.9961z" fill="url(#S)" />
    <path
      d="m62.4883 9.16406 13.2812 6.30864v19.0585c-4.582-2.1914-35.2617-16.8007-35.2617-16.8007s2.125-4.4493 4.1172-8.56644z"
      fill="url(#T)"
    />
    <path
      d="m29.5508 73.1797c-.1993.3985-.5313.8633-.4649 1.5938.0664 2.7226 4.5156 5.2461 7.1055 5.2461 1.7929 0 2.3906-.7305 3.0547-2.0586.664-1.3281-8.9649-6.375-9.6953-4.7813z"
      fill="url(#U)"
    />
    <path
      d="m60.1641 16.668s6.8398 1.6601 7.3711 2.125c.5312.4648-.8633 3.1211-1.129 3.5195-2.1914 2.6562-9.0312 17.332-9.0312 17.332l-6.3086-3.5859s5.6445-10.4922 7.6367-14.2109c1.2617-2.5235 1.461-5.1797 1.461-5.1797z"
      fill="url(#V)"
    />
    <path
      d="m75.9688 13.215c1.1953.8633 2.7891.664 4.0508.4648.8633-.1328-.4649 1.1289-1.9258 4.0508s-1.3945 3.1211-1.5938 2.9219c-.1992-.1992-6.7734-3.918-6.5742-4.25.2656-.3321 1.3281-7.57034 1.8594-7.37112 1.9258.46484 2.2578 2.78902 4.1836 4.18362z"
      fill="url(#W)"
    />
    <path
      d="m65.7422 21.3828c.4648-.7305 2.5898-5.2461 5.9766-5.2461 1.5273 0 4.4492 3.8516 4.7148 4.3828.1992.4649-.4648 2.3242-.7969 1.461-.3984-.9961-2.0586-3.1211-3.8515-3.1211-1.793 0-4.25 2.0586-4.8477 2.789-.5977.6641-1.6602.4649-1.1953-.2656z"
      fill="url(#X)"
    />
    <path
      d="m65.6094 21.1169c.332-.5312 1.8593-2.8554 2.5898-3.5859s2.5898-2.6562 4.1836-2.9219c1.5937-.2656 3.2539 2.9883 2.7227 3.6524-.3985.4648-1.0625-.0664-1.8594-.7305-.7969-.5977-1.3281-1.793-3.8516.1328-.8633.6641-1.7265 1.1953-3.7187 4.0508-.5313.7305-.3985-.0664-.0664-.5977z"
      fill="url(#Y)"
    />
    <path
      d="m57.375 40.5078c.2656-.5313.5976-1.3281-.1328-1.9258-.7969-.5976-4.5156-2.5898-5.1797-2.7226-.6641-.1329-1.1953 0-1.461.4648-.2656.4648-20.6523 35.3945-21.0507 36.3906-.3985.9961-.4649 1.7266.1328 1.9258.5976.1992 7.4375 3.4531 8.1015 4.1836.6641.7305.9961-.0664 1.2618-.4648 1.2617-1.5938 17.9961-37.3204 18.3281-37.8516z"
      fill="url(#Z)"
    />
    <path
      d="m66.0742 20.9844c.3321-.4649 1.1289-1.793 2.125-2.9883.6641-.7969 4.25-2.5234 5.0469-5.3125.4648-1.5274-.2656-3.05469-1.2617-3.71876-3.3867-2.05859-9.2305-5.3125-17.7969-5.3125-5.7773 0-8.2344 1.92578-8.2344 1.92578h2.9219l10.1602 3.98438 1.2617 5.3125s.1328 1.793-.4649 3.8516c-.3984 1.6601-.5312 2.6562-1.1289 4.3164.4649.1992 1.5274-.5313 2.7227-.1992 1.0625.2656 1.7265 1.7265 2.457.8632 1.2617-1.6601 1.6602-1.9922 2.1914-2.7226z"
      fill="url(#aa)"
    />
    <path
      d="m60.0977 16.8672c-.5313-4.9141-1.7266-9.56253-14.211-9.49613.7969-.79687 2.7227-1.59375 2.7227-1.59375l-2.7227-.19922s.3985-.33203 1.1953-.39843c7.3047-.59766 13.8125.92969 13.3477 10.42573-.0664 1.5274-.1992 2.1915-.332 1.2618z"
      fill="url(#ab)"
    />
    <path
      d="m45.8867 7.37128c.8633-.33203 2.0586-.53125 4.3164-.39844 2.7891.13282 6.3086 1.19532 7.7696 2.52344.7304.66402.664.13281-.1329-.73047-2.0586-2.39062-5.1796-2.92187-9.2304-2.98828-.4649-.06641-1.9922.79688-2.7227 1.59375z"
      fill="url(#ac)"
    />
    <path
      d="m80.1523 13.6797 3.6524 1.8594s-1.3945 1.8593-2.5234 3.9843c-1.1954 2.2578-1.9922 4.7149-1.9922 4.7149l-3.5196-2.125s.8633-2.3906 2.125-4.7149c.9961-1.9257 2.2578-3.7187 2.2578-3.7187z"
      fill="url(#ad)"
    />
    <path
      d="m83.8047 15.5389c.2656.1328-.5977 2.1914-1.8594 4.5821-1.2617 2.3906-2.457 4.25-2.6563 4.1171-.2656-.1328.5977-2.1914 1.8594-4.582 1.1953-2.3906 2.3906-4.25 2.6563-4.1172z"
      fill="#bfc0d0"
    />
  </svg>
)

try{ XcodeLogo.displayName ||= 'XcodeLogo' } catch {}